import { getLastPeriodDates } from '../../GroupMetricsTable/GroupMetricsTable.service';
import useGroupMetrics from '../useGroupMetrics/useGroupMetrics';
import {
  GRANULARITY_TO_METRICS_V2_GRANULARITY,
  GRANULARITY
} from '../../../../performance/views/CustomReport/consts';
import { useSelector } from 'react-redux';
import {
  selectedPeriodKeySelector,
  uiStateSelector
} from 'state/selectors/ui-state';
import { prevIterationSelector } from 'state/selectors/iterations-picker';
import { getGranularityByDates } from '../../../../performance/views/CustomReport/custom-report.util';
import useMetricsCalculationConfig from 'views/root/views/home/hooks/useMetricsCalculationConfig';

const useGroupTableData = ({ selectedGroup, metricsNames, gitScopeToggle }) => {
  const uiState = useSelector(uiStateSelector);
  const { dates } = uiState;
  const selectedPeriodKey = useSelector(selectedPeriodKeySelector);
  const prevIteration = useSelector(prevIterationSelector);
  const metricsCalculationConfig = useMetricsCalculationConfig();
  const { metricsCalculationStrategy } = metricsCalculationConfig;

  // current period data for the table
  const { isLoading, metrics } = useGroupMetrics({
    metricsNames,
    dates,
    metricsCalculationStrategy,
    selectedGroup,
    gitScopeToggle
  });

  const granularity = getGranularityByDates({
    start_date: dates.from,
    end_date: dates.to,
    selectedGranularity: GRANULARITY.AUTO
  });

  const {
    isLoading: metricsPerGranularityLoading,
    metrics: metricsPerGranularity
  } = useGroupMetrics({
    metricsNames,
    dates,
    metricsCalculationStrategy,
    selectedGroup,
    roll_up: GRANULARITY_TO_METRICS_V2_GRANULARITY[granularity],
    gitScopeToggle
  });

  // last period data - for the arrows in the table
  const lastPeriodDates = getLastPeriodDates(selectedPeriodKey, prevIteration);
  const granularityLastPeriod = lastPeriodDates
    ? getGranularityByDates({
        start_date: lastPeriodDates.from,
        end_date: lastPeriodDates.to,
        selectedGranularity: GRANULARITY.AUTO
      })
    : GRANULARITY.AUTO;

  const { metrics: aggregatedLastPeriodMetrics } = useGroupMetrics({
    metricsNames,
    dates: lastPeriodDates,
    metricsCalculationStrategy,
    selectedGroup,
    gitScopeToggle
  });

  const { metrics: metricsPerGranularityLastPeriod } = useGroupMetrics({
    metricsNames,
    dates: lastPeriodDates,
    metricsCalculationStrategy,
    selectedGroup,
    roll_up: GRANULARITY_TO_METRICS_V2_GRANULARITY[granularityLastPeriod],
    gitScopeToggle
  });

  return {
    isLoading,
    metrics,
    metricsPerGranularityLoading,
    metricsPerGranularity,
    aggregatedLastPeriodMetrics,
    metricsPerGranularityLastPeriod,
    lastPeriodDates
  };
};

export default useGroupTableData;
